module.exports = "/_next/static/images/b2875ef4d0c7192ad202796fa6646f96-choose-money-box.png.webp";